import { Tag } from 'antd'
import { Sort } from 'iconsax-react'
import { IFilter } from 'constants/tags'

interface VoucherTagsProps {
  Tags: IFilter[]
  selectedTags: IFilter[]
  onOpenModalTags: (status: boolean) => void
  onSelectTag: (selectTag: IFilter) => void
}

export default function VoucherTags(props: VoucherTagsProps) {
  const { Tags, selectedTags, onSelectTag, onOpenModalTags } = props

  const tagClassName =
    'select-none text-[#323539] border border-[#E5E5E7] p-2 rounded-lg hover:cursor-pointer'

  return (
    <div>
      <Tag
        data-testid="button-"
        color="#fff"
        className={tagClassName}
        icon={<Sort size={12} />}
        onClick={() => onOpenModalTags(true)}
      >
        <div className="ml-2 inline-block">Filter</div>
      </Tag>
      {Tags.map(filter => (
        <Tag
          key={filter.value}
          color={selectedTags.some(item => item.value === filter.value) ? '#F4F6F0' : '#fff'}
          className={tagClassName}
          onClick={() => onSelectTag(filter)}
        >
          {filter.label}
        </Tag>
      ))}
    </div>
  )
}
